module.exports = __webpack_public_path__ + "static/bkg-successful-farming.a3c543a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bkg-successful-farming.jpg
// module id = 602
// module chunks = 35783957827783